import React from "react";

import { useTranslation } from "react-i18next";

import { TextInput as Text } from "@caelor/ui";
import IconPicker from "../../../../../../../components/ui/icon-picker/IconPicker";
import {
  OptionContainer,
  OptionContent,
  OptionLabel,
  SettingsOptionContainer,
  SettingsOptionHeading,
} from "../../../styles";
import { useAdvancedTabsSingleStore } from "../../../../../../../stores/use-advanced-tabs-single-store";
import { ADVANCED_TABS_SINGLE_PROP } from "./defaults";

const AdvancedTabsSingleSettings = () => {
  const { data, setData } = useAdvancedTabsSingleStore((state) => ({
    data: state.data,
    setData: state.setData,
  }));

  const { t } = useTranslation();
  return (
    <>
      <SettingsOptionContainer>
        <SettingsOptionHeading>{t("content")}</SettingsOptionHeading>
        <OptionContainer>
          <OptionLabel>{t("title")}</OptionLabel>
          <OptionContent>
            <Text
              placeholder={t("add")}
              value={data[ADVANCED_TABS_SINGLE_PROP.TITLE]}
              onChange={(value) =>
                setData({ [ADVANCED_TABS_SINGLE_PROP.TITLE]: value })
              }
            />
          </OptionContent>
        </OptionContainer>
        <OptionContainer>
          <OptionLabel>{t("icon")}</OptionLabel>
          <OptionContent>
            <IconPicker
              defaultTab={t("icons")}
              tabs={[t("icons")]}
              icon={data[ADVANCED_TABS_SINGLE_PROP.ICON]}
              onChange={({ value }) =>
                setData({ [ADVANCED_TABS_SINGLE_PROP.ICON]: value })
              }
            />
          </OptionContent>
        </OptionContainer>
      </SettingsOptionContainer>
    </>
  );
};

export default AdvancedTabsSingleSettings;
